import { create } from 'zustand';

export type NavTab = 'live' | 'stores' | 'pipeline' | 'economy' | 'rules';
export type LiveSubTab = 'floor_map' | 'activite' | 'detail_agent' | 'zones';

interface UIState {
  activeTab: NavTab;
  liveSubTab: LiveSubTab;
  selectedAgentId: string | null;
  selectedStoreId: string | null;
  selectedTaskId: string | null;
  highlightedRoomId: string | null;
  sidebarCollapsed: boolean;

  setActiveTab: (tab: NavTab) => void;
  setLiveSubTab: (tab: LiveSubTab) => void;
  selectAgent: (id: string | null) => void;
  selectStore: (id: string | null) => void;
  selectTask: (id: string | null) => void;
  highlightRoom: (id: string | null) => void;
  toggleSidebar: () => void;
}

export const useUIStore = create<UIState>(set => ({
  activeTab: 'live',
  liveSubTab: 'floor_map',
  selectedAgentId: null,
  selectedStoreId: null,
  selectedTaskId: null,
  highlightedRoomId: null,
  sidebarCollapsed: false,

  setActiveTab: (tab) => set({ activeTab: tab }),
  setLiveSubTab: (tab) => set({ liveSubTab: tab }),
  selectAgent: (id) => set({ selectedAgentId: id }),
  selectStore: (id) => set({ selectedStoreId: id }),
  selectTask: (id) => set({ selectedTaskId: id }),
  highlightRoom: (id) => set({ highlightedRoomId: id }),
  toggleSidebar: () => set(s => ({ sidebarCollapsed: !s.sidebarCollapsed })),
}));
